/*
 * Copyright (c) 2023
 * 
 * Created Date: Thursday, July 6th 2023, 12:36:55 pm
 * Author: 🫰Aris Bimas Nugroho
 * 
 */


import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"

const REPO_URL = {
    getConfigByKey: '/Config/getbykey',
    getRSAPublicKey: '/Config/get_rsa_public_key'
}

const useConfigRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

    const getConfigByKey = async (payload) => {
        return await executeApi(REPO_URL.getConfigByKey, BASE_API_CONSTANT.METHOD.POST, payload)
    }

    const getRSAPublicKey = async () => {
        return await executeApi(REPO_URL.getRSAPublicKey, BASE_API_CONSTANT.METHOD.POST, {}, { isUnauthenticated: true })
    }

    return {
        isLoading,
        data,
        error,
        getConfigByKey,
        getRSAPublicKey
    }
}

export default useConfigRepo
